module.exports = __webpack_public_path__ + "img/answer-capacitor.fbea304e.png";